import axios from 'axios'
import { Message } from 'element-ui'

export function resolveBaseURL() {
  const env = process.env.VUE_APP_API_BASE || '/api'
  // 旧 mock 地址或绝对地址会导致 devServer 代理失效
  if (/https?:\/\//.test(env)) {
    if (/:(8080|8082|8081)\/api/.test(env)) return '/api'
    return env
  }
  return env
}

const request = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 60000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('faq_admin_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

/** 已经通过 Message 提示过的接口错误：全局兜底与 dev 红屏遮罩据此忽略，避免一次接口失败顶掉整个页面 */
export function apiError(msg) {
  const err = new Error(msg)
  err.isApiError = true
  return err
}

function formatHttpError(err) {
  const status = err.response && err.response.status
  const body = err.response && err.response.data
  if (typeof body === 'string' && body.indexOf('Cannot GET /api') >= 0) {
    return '接口代理未生效：请用 npm run serve 启动（勿直接打开 dist），并确保 8082 端口未被占用'
  }
  if (body && body.msg) return body.msg
  if (status === 404) return '接口不存在(404)，请确认已 npm run serve 且代理到 faq-test.runde.pro'
  return err.message || '请求失败'
}

request.interceptors.response.use(
  res => {
    const body = res.data
    if (!body || typeof body.code === 'undefined') return body
    if (body.code === 401 || body.code === 403) {
      const msg = body.msg || '请先登录'
      if (window.location.hash.indexOf('#/login') !== 0) {
        Message.error(msg)
      }
      localStorage.removeItem('faq_admin_token')
      localStorage.removeItem('faq_admin_user')
      if (window.location.hash.indexOf('#/login') !== 0) {
        window.location.hash = '#/login'
      }
      return Promise.reject(apiError(msg))
    }
    if (body.code !== 200) {
      const msg = body.msg || '请求失败'
      Message.error(msg)
      return Promise.reject(apiError(msg))
    }
    return { code: 0, data: body.data, msg: body.msg, msgCode: body.msg_code }
  },
  err => {
    const msg = formatHttpError(err)
    Message.error(msg)
    return Promise.reject(apiError(msg))
  }
)

export default request
